import React from "react";
import {
  FaEnvelope,
  FaFacebookF,
  FaXTwitter,
  FaRedditAlien,
  FaLinkedinIn,
} from "react-icons/fa6";
import { FaTelegram, FaCalendarAlt } from "react-icons/fa";
import Footer from "../component/Footer";
import Navbar from "../component/Navbar";
import HeadingWithWatermark from "../component/HeadingWithWatermark";

const reports = [
  {
    id: 1,
    category: "29th ICSME 2025 Report",
    date: "19 December 2025",
    title:
      "29th ICSME 2025 Report",
    image: "/img/icsme_19th.png",
  },
  {
    id: 2,
    category: "Cyber and Technology",
    date: "30th April 2025",
    title: "Exclusive Interaction: Unleashing Global MSMEs Collaborations with Ecuador",
    image: "/img/report4.png",
  },
  {
    id: 3,
    category: "Cyber and Technology",
    date: "24 April 2025",
    title: "The Thursday Thing: The Women's Chapter",
    image: "/img/report6.png",
  },
];

const EventReportCard = ({ report }) => {
  const skyBlue = "rgb(43, 147, 208)";

  return (
    <div className="flex flex-col md:flex-row gap-8 items-start">

      {/* Image */}
      <img
        src={report.image}
        alt={report.title}
        className="w-full md:w-[420px] h-[250px] object-cover"
      />

      {/* Content */}
      <div className="flex flex-col space-y-3">

      

        {/* Icons + Date */}
        <div className="flex items-center space-x-4 text-sm">

          <div className="flex items-center space-x-3" style={{ color: skyBlue }}>
            <FaEnvelope className="cursor-pointer hover:opacity-70" />
            <FaFacebookF className="cursor-pointer hover:opacity-70" />
            <FaXTwitter className="cursor-pointer hover:opacity-70" />
            {/* <FaRedditAlien className="cursor-pointer hover:opacity-70" /> */}
            <FaLinkedinIn className="cursor-pointer hover:opacity-70" />
            {/* <FaTelegram className="cursor-pointer hover:opacity-70" /> */}
          </div>

          <div className="flex items-center text-gray-700 ml-4">
            <FaCalendarAlt className="mr-2" style={{ color: skyBlue }} />
            {report.date}
          </div>

        </div>

        {/* Title */}
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 leading-snug max-w-3xl">
          {report.title}
        </h2>

      </div>
    </div>
  );
};

const EventReportsPage = () => {
  return (
    <>
    <Navbar/>
      <div className="bg-gray-50 min-h-screen">

      <div className="max-w-7xl mx-auto px-6 py-14">

        <HeadingWithWatermark
          title="Events Reports"
          watermarkText="WASME"
          color="#1b73a7"
          align="center"
        />

        <div className="space-y-16">
          {reports.map((report) => (
            <EventReportCard key={report.id} report={report} />
          ))}
        </div>

      </div>

    </div>
    <Footer/>
    </>
  
  );
};

export default EventReportsPage;